import React , { useEffect }from 'react'
import { withRouter } from "../../../hooks/withRouter";
import { useNavigate } from 'react-router-dom';
// import loadImg from "@Images/NewUI/hourglass.png";
import loadImg from "@Images/NewUI/loading_glass.gif";

const Kycnew = (props) => {
  const navigate = useNavigate();

  const handleUpdateKyc = () => {
    
    navigate("/manual_verify?keyfrom=kycchange");
  };
  
  const handleBackToHome = () => {
   
    navigate("/super-loan-dashboard");
  };
  
  
  return (
   <>
   {/* {kyc=== Verified ? : } */}
   <div className='container'>
   <div className="wrapper-content kyc_margin">
                    <div className="kyccard-height px-4 pb-3 pt-1 w-100 text-center mx-auto rounded-40 ">
                      <div className="d-flex flex-column justify-content-between">
                        <div className="pt-4 pb-5">
                        <img
                            src={loadImg}
                            alt="loadImg"
                            className="pop_kyc"
                        />
                        
                        <h1 className='kycVerificationfont'>KYC Verification <br/> in process</h1>
                        <h1 className='kycparagraph mb-3'>Your KYC verification is underway!</h1>
                        
                        <p className='kycparagraph mb-30'>Once it's complete, you can proceed with Your loan application</p>
                        <span  onClick={handleUpdateKyc}
                           className='changekyc'>Update KYC Details</span>
                        </div>
                      </div>
                    </div>
                    <div className="text-center pt-4 setmoney_div">
                        <div
                        className="GetNowBtnrepayvd"
                        onClick={handleBackToHome}
                        >
                        Back To Home
                        </div>
                      </div>
                    
    </div>
   </div>
   </>
  )
}

export default withRouter(Kycnew)